export var PageType;
(function (PageType) {
    // Product List Page / collection page
    PageType["PLP"] = "plp";
    // Product Detail Page
    PageType["PDP"] = "pdp";
})(PageType || (PageType = {}));



// WEBPACK FOOTER //
// ./~/@psykhe-ai/browser-plugin-snowplow-ecommerce/dist/types.js